import _ from 'lodash';
import { CardViewState } from '../reducers';
import { EHubConfig } from '../types';

export const getCardViewConfig = (state: {}, moduleName: string) => {
  return _.get(state, `hk-emma-web-core/app.moduleConfig.${moduleName}`, {});
};

export const getCardViewState = (
  state: {},
  reducerName: string,
  reducerSubName = 'ehub',
): CardViewState => {
  return _.get(
    state,
    `hk-emma-web-core/${reducerName}.${reducerSubName}.config`,
    {},
  );
};

export const getEHubConfig = (state: {}, ehubId: string): EHubConfig => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-e-hub.${ehubId}`,
    {},
  );
};

export const getAuthToken = (
  state: {},
  reducerName: string,
  reducerSubName = 'ehub',
): string => {
  return _.get(
    state,
    `hk-emma-web-core/${reducerName}.${reducerSubName}.authToken`,
    '',
  );
};

export const getAuthTokenParamName = (
  state: {},
  reducerName: string,
  reducerSubName = 'ehub',
): string => {
  return _.get(
    state,
    `hk-emma-web-core/${reducerName}.${reducerSubName}.config.ehubAuthToken.authTokenParamName`,
    '',
  );
};
